/* =========================================================
   Knee theme — shared scripts (no dependencies)
   ========================================================= */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const theme = window.theme || {};
  const overlay = $('[data-overlay]');

  const store = {
    get(key, fallback) { try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage unavailable */ } }
  };

  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  let toastTimer;
  function toast(message) {
    let el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Announcement bar ---------- */
  function initAnnouncement() {
    const bar = $('[data-announcement]');
    if (!bar) return;
    try { if (sessionStorage.getItem('announcement-closed')) { bar.hidden = true; return; } } catch (e) { /* ignore */ }
    const messages = $$('.announcement__message', bar);
    const rotator = $('[data-rotator]', bar);
    if (messages.length > 1) {
      let i = 0;
      setInterval(() => {
        messages[i].classList.remove('is-active');
        i = (i + 1) % messages.length;
        messages[i].classList.add('is-active');
      }, Number(rotator.dataset.interval) || 5000);
    }
    $('[data-announcement-close]', bar).addEventListener('click', () => {
      bar.hidden = true;
      try { sessionStorage.setItem('announcement-closed', '1'); } catch (e) { /* ignore */ }
    });
  }

  /* ---------- Drawers & modals ---------- */
  function openLayer(el) {
    if (!el) return;
    closeAll();
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-visible');
    document.body.classList.add('is-locked');
    const focusable = el.querySelector('button, a, input');
    focusable && setTimeout(() => focusable.focus({ preventScroll: true }), 50);
  }
  function closeAll() {
    $$('[data-drawer].is-open, [data-modal].is-open, [data-search-overlay].is-open').forEach((el) => {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    overlay && overlay.classList.remove('is-visible');
    document.body.classList.remove('is-locked');
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.drawerOpen);
      if (target) { e.preventDefault(); openLayer(target); }
      return;
    }
    const modalOpener = e.target.closest('[data-modal-open]');
    if (modalOpener) {
      e.preventDefault();
      const inlineChart = modalOpener.dataset.modalOpen === 'size-guide' && document.getElementById('size-chart-desktop');
      if (inlineChart && inlineChart.offsetParent !== null) {
        inlineChart.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      openLayer(document.getElementById(modalOpener.dataset.modalOpen));
      return;
    }
    if (e.target.closest('[data-drawer-close], [data-modal-close], [data-search-close]') || e.target === overlay) {
      closeAll();
      return;
    }
    if (e.target.matches('[data-modal]')) closeAll();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeAll(); closeDropdowns(); } });

  /* ---------- Search (predictive) ---------- */
  function initSearch() {
    const overlayEl = $('[data-search-overlay]');
    if (!overlayEl) return;
    const input = $('[data-predictive-input]', overlayEl);
    $$('[data-search-open]').forEach((btn) => btn.addEventListener('click', () => {
      openLayer(overlayEl);
      setTimeout(() => input.focus(), 60);
    }));
    const results = $('[data-predictive-results]', overlayEl);
    $$('[data-search-trigger] input[type="search"]').forEach((trigger) => {
      trigger.addEventListener('focus', () => {
        openLayer(overlayEl);
        input.value = trigger.value;
        setTimeout(() => input.focus(), 60);
        trigger.blur();
      });
    });
    let timer;
    let controller;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        controller && controller.abort();
        controller = new AbortController();
        try {
          const url = `${theme.routes.root}search/suggest?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=4&section_id=predictive-search`;
          const res = await fetch(url, { signal: controller.signal });
          const doc = parseHTML(await res.text());
          const section = doc.querySelector('#shopify-section-predictive-search');
          results.innerHTML = section ? section.innerHTML : '';
          syncWishlistButtons(results);
        } catch (err) { if (err.name !== 'AbortError') results.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- Carousels ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    const carousel = btn.closest('[data-carousel]');
    const track = carousel && $('[data-carousel-track]', carousel);
    if (!track) return;
    const dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- Hero slideshow ---------- */
  function initSlideshows() {
    $$('[data-slideshow]').forEach((show) => {
      const slides = $$('.hero__slide', show);
      const dots = $$('[data-slide-to]', show);
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const go = (i) => {
        slides[index].classList.remove('is-active'); dots[index] && dots[index].classList.remove('is-active');
        index = (i + slides.length) % slides.length;
        slides[index].classList.add('is-active'); dots[index] && dots[index].classList.add('is-active');
      };
      const interval = Number(show.dataset.interval);
      const start = () => { if (interval > 0) { clearInterval(timer); timer = setInterval(() => go(index + 1), interval); } };
      dots.forEach((dot) => dot.addEventListener('click', () => { go(Number(dot.dataset.slideTo)); start(); }));
      let startX = null;
      show.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      show.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); start(); }
        startX = null;
      });
      start();
    });
  }

  /* ---------- Cart ---------- */
  const cartSection = 'cart-drawer';

  function renderCart(sections) {
    if (!sections || !sections[cartSection]) return;
    const wrapper = document.getElementById(`shopify-section-${cartSection}`);
    const wasOpen = $('[data-cart-drawer]') && $('[data-cart-drawer]').classList.contains('is-open');
    const doc = parseHTML(sections[cartSection]);
    const fresh = doc.querySelector(`#shopify-section-${cartSection}`) || doc.body;
    if (wrapper) wrapper.innerHTML = fresh.innerHTML;
    const count = $('[data-cart-count-source]');
    if (count) {
      $$('[data-cart-count]').forEach((el) => { el.textContent = count.textContent; el.hidden = count.textContent.trim() === '0'; });
    }
    if (wasOpen) {
      const drawer = $('[data-cart-drawer]');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }
  }

  async function addToCart(variantId, quantity = 1, button) {
    button && button.classList.add('is-loading');
    try {
      const res = await fetch(`${theme.routes.cart_add}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: Array.isArray(variantId) ? variantId : [{ id: Number(variantId), quantity }], sections: [cartSection] })
      });
      const data = await res.json();
      if (!res.ok || data.status) { toast(data.description || data.message || 'Error'); return false; }
      if (theme.cartType === 'page') { window.location.href = theme.routes.cart; return true; }
      renderCart(data.sections);
      openLayer($('[data-cart-drawer]'));
      return true;
    } catch (err) {
      toast('Something went wrong. Please try again.');
      return false;
    } finally {
      button && button.classList.remove('is-loading');
    }
  }

  window.kpAddToCart = addToCart;

  async function changeLine(key, quantity) {
    const drawer = $('[data-cart-drawer]');
    drawer && drawer.classList.add('is-busy');
    try {
      const res = await fetch(`${theme.routes.cart_change}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: [cartSection] })
      });
      const data = await res.json();
      if (data.status) toast(data.description || data.message);
      renderCart(data.sections);
    } finally {
      drawer && drawer.classList.remove('is-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const change = e.target.closest('[data-cart-change]');
    if (change) { e.preventDefault(); changeLine(change.dataset.cartChange, Math.max(0, Number(change.dataset.qty))); return; }

    const nudgeBtn = e.target.closest('[data-cart-nudge-add]');
    if (nudgeBtn) {
      e.preventDefault();
      const sel = $('[data-cart-nudge-select]');
      if (sel && sel.value) addToCart(sel.value, 1, nudgeBtn);
      return;
    }

    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      addToCart(quick.dataset.quickAdd, 1, quick).then((ok) => {
        if (ok && quick.classList.contains('size-chip')) {
          quick.classList.add('is-added');
          setTimeout(() => quick.classList.remove('is-added'), 1500);
        }
        const card = quick.closest('[data-product-card]');
        card && card.classList.remove('is-quick-open');
      });
      return;
    }

    const toggle = e.target.closest('[data-quick-toggle]');
    if (toggle) {
      e.preventDefault();
      const card = toggle.closest('[data-product-card]');
      $$('[data-product-card].is-quick-open').forEach((c) => c !== card && c.classList.remove('is-quick-open'));
      card.classList.toggle('is-quick-open');
      return;
    }
    if (!e.target.closest('[data-quick-panel]')) $$('[data-product-card].is-quick-open').forEach((c) => c.classList.remove('is-quick-open'));
  });

  /* ---------- Wishlist (saved in the browser) ---------- */
  const WISHLIST_KEY = 'wishlist';
  function getWishlist() { return store.get(WISHLIST_KEY, []); }
  function syncWishlistButtons(ctx = document) {
    const list = getWishlist();
    $$('[data-wishlist-toggle]', ctx).forEach((btn) => btn.setAttribute('aria-pressed', list.includes(btn.dataset.wishlistToggle) ? 'true' : 'false'));
    $$('[data-wishlist-count]').forEach((el) => { el.hidden = list.length === 0; });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.wishlistToggle;
    let list = getWishlist();
    list = list.includes(handle) ? list.filter((h) => h !== handle) : [handle, ...list];
    store.set(WISHLIST_KEY, list.slice(0, 100));
    syncWishlistButtons();
    const page = $('[data-wishlist-page]');
    if (page && !list.includes(handle)) { const card = btn.closest('li'); card && card.remove(); updateWishlistEmpty(); }
  });
  function updateWishlistEmpty() {
    const grid = $('[data-wishlist-grid]');
    const empty = $('[data-wishlist-empty]');
    if (grid && empty) empty.hidden = grid.children.length > 0;
  }
  async function initWishlistPage() {
    const grid = $('[data-wishlist-grid]');
    if (!grid) return;
    const list = getWishlist();
    const cards = await Promise.all(list.map(async (handle) => {
      try {
        const res = await fetch(`${theme.routes.root}products/${encodeURIComponent(handle)}?section_id=product-card-render`);
        if (!res.ok) return null;
        const doc = parseHTML(await res.text());
        const card = doc.querySelector('[data-product-card]');
        return card ? card.outerHTML : null;
      } catch (e) { return null; }
    }));
    grid.innerHTML = cards.filter(Boolean).map((html) => `<li>${html}</li>`).join('');
    syncWishlistButtons(grid);
    updateWishlistEmpty();
  }

  /* ---------- Collection: filters, sort, load more ---------- */
  function closeDropdowns(except) {
    $$('[data-dropdown].is-open').forEach((d) => {
      if (d === except) return;
      d.classList.remove('is-open');
      const t = $('[data-dropdown-toggle]', d); t && t.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-dropdown-toggle]');
    if (toggle) {
      const dd = toggle.closest('[data-dropdown]');
      closeDropdowns(dd);
      const open = dd.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!e.target.closest('[data-dropdown]')) closeDropdowns();
  });

  function formToUrl(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => { if (value !== '') params.append(key, value); });
    return `${window.location.pathname}?${params.toString()}`;
  }

  async function renderCollection(url, { push = true } = {}) {
    const root = $('[data-collection-root]');
    const section = $('[data-collection]');
    if (!root || !section) { window.location.href = url; return; }
    const openDropdown = $('[data-dropdown].is-open');
    const openId = openDropdown && openDropdown.dataset.dropdownId;
    const drawerOpen = !!$('[data-collection-root] [data-drawer].is-open');
    const grid = $('[data-product-grid]', root);
    grid && grid.classList.add('is-loading');
    try {
      const sep = url.includes('?') ? '&' : '?';
      const res = await fetch(`${url}${sep}section_id=${section.dataset.sectionId}`);
      const doc = parseHTML(await res.text());
      const freshRoot = doc.querySelector('[data-collection-root]');
      if (!freshRoot) { window.location.href = url; return; }
      root.innerHTML = freshRoot.innerHTML;
      const count = doc.querySelector('.collection__count');
      const currentCount = $('.collection__count');
      if (count && currentCount) currentCount.textContent = count.textContent;
      if (push) history.pushState({ collection: true }, '', url);
      syncWishlistButtons(root);
      if (openId) {
        const dd = $(`[data-dropdown][data-dropdown-id="${CSS.escape(openId)}"]`, root);
        if (dd) { dd.classList.add('is-open'); $('[data-dropdown-toggle]', dd).setAttribute('aria-expanded', 'true'); }
      }
      if (drawerOpen) {
        const drawer = $('[data-drawer]', root);
        drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      }
    } catch (err) {
      window.location.href = url;
    }
  }

  let facetTimer;
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-facet-form]');
    if (!form) return;
    clearTimeout(facetTimer);
    const delay = e.target.type === 'number' ? 600 : 0;
    facetTimer = setTimeout(() => renderCollection(formToUrl(form)), delay);
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-facet-form]');
    if (!form) return;
    e.preventDefault();
    renderCollection(formToUrl(form));
  });
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-facet-link]');
    if (!link) return;
    e.preventDefault();
    renderCollection(link.href);
  });
  window.addEventListener('popstate', (e) => {
    if ($('[data-collection]')) renderCollection(window.location.href, { push: false });
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-load-more-btn]');
    if (!btn) return;
    e.preventDefault();
    const section = $('[data-collection]');
    btn.classList.add('is-loading');
    try {
      const url = btn.href;
      const sep = url.includes('?') ? '&' : '?';
      const res = await fetch(`${url}${sep}section_id=${section.dataset.sectionId}`);
      const doc = parseHTML(await res.text());
      const items = doc.querySelectorAll('[data-product-grid] > li');
      const grid = $('[data-product-grid]');
      items.forEach((li) => grid.appendChild(li));
      const freshLoadMore = doc.querySelector('[data-load-more]');
      const loadMore = $('[data-load-more]');
      if (freshLoadMore && loadMore) loadMore.replaceWith(freshLoadMore);
      syncWishlistButtons(grid);
      history.replaceState({}, '', url);
    } catch (err) {
      window.location.href = btn.href;
    }
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-read-more-toggle]');
    if (!btn) return;
    const box = btn.closest('[data-read-more]');
    const expanded = box.classList.toggle('is-expanded');
    btn.textContent = expanded ? btn.dataset.less : btn.dataset.more;
  });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const picker = $('[data-variant-picker]', section);
    const form = $('form.product-form', section);
    const idInput = form && $('[data-variant-id]', form);
    const addBtn = form && $('[data-add-button]', form);
    const stockNote = $('[data-stock-note]', section);
    const sizeError = $('[data-size-error]', section);
    const track = $('[data-gallery-track]', section);
    const thumbs = $$('[data-thumb]', section);
    const dots = $$('.gallery__dots span', section);
    const sticky = $('[data-sticky-atc]', section);
    const stickyBtn = $('[data-sticky-atc-btn]', section);
    const buyNowBtn = $('[data-buy-now]', section);
    const expressGuard = $('[data-express-guard]', section);
    let sizeChosen = section.dataset.sizeRequired !== 'true';
    if (expressGuard) expressGuard.hidden = sizeChosen;

    function selectedOptions() {
      if (!picker) return null;
      return $$('.variant-picker__group', picker).map((group) => {
        const checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return data.variants.find((v) => v.options.every((opt, i) => options[i] === null || options[i] === undefined || opt === options[i]));
    }

    const slides = () => (track ? $$('.gallery__slide', track) : []);
    const prevBtn = $('[data-gallery-prev]', section);
    const nextBtn = $('[data-gallery-next]', section);

    function currentIndex() {
      return track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
    }

    // Horizontal carousel: scroll the track to a slide (same behaviour on mobile and desktop)
    function showSlide(index) {
      const list = slides();
      if (!list.length) return;
      const i = Math.max(0, Math.min(index, list.length - 1));
      track.scrollTo({ left: list[i].offsetLeft - list[0].offsetLeft, behavior: 'smooth' });
    }

    function showMedia(mediaId) {
      const index = slides().findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (index > -1) showSlide(index);
    }
    const goToMedia = showMedia;

    function syncGallery() {
      const index = currentIndex();
      const list = slides();
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      const activeId = list[index] && list[index].dataset.mediaId;
      thumbs.forEach((t) => {
        const on = t.dataset.thumb === activeId;
        t.classList.toggle('is-active', on);
        if (on) {
          const bar = t.closest('.gallery__thumbs');
          if (bar) bar.scrollTo({ left: t.offsetLeft - bar.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      });
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= list.length - 1;
    }

    function updateAvailability(options) {
      if (!picker) return;
      $$('.variant-picker__group', picker).forEach((group, groupIndex) => {
        $$('input[data-option-input]', group).forEach((input) => {
          const test = options.slice();
          test[groupIndex] = input.value;
          const match = data.variants.find((v) => v.options.every((opt, i) => test[i] === null || opt === test[i]));
          const label = input.closest('label');
          label && label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function setButtonState(variant) {
      const buttons = [addBtn, stickyBtn].filter(Boolean);
      buttons.forEach((b) => {
        if (!variant) { b.disabled = true; b.textContent = theme.strings.unavailable; }
        else if (!variant.available) { b.disabled = true; b.textContent = theme.strings.soldOut; }
        else { b.disabled = false; b.textContent = theme.strings.addToCart; }
      });
      if (buyNowBtn) buyNowBtn.disabled = !variant || !variant.available;
    }

    function update(fromUser) {
      const options = selectedOptions();
      if (!options) return;
      updateAvailability(options);
      $$('.variant-picker__group', picker).forEach((group, i) => {
        const label = $('[data-option-label]', group);
        if (label && options[i]) label.textContent = options[i];
      });
      if (data.sizeIndex > -1 && options[data.sizeIndex] === null) {
        const partial = findVariant(options);
        setButtonState(partial);
        if (fromUser && partial && partial.mediaId) goToMedia(partial.mediaId);
        return;
      }
      const variant = data.variants.find((v) => v.options.every((opt, i) => opt === options[i]));
      setButtonState(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      $$('[data-product-price]', section).forEach((el) => {
        const sale = variant.compare > variant.price;
        const percent = sale ? Math.floor(((variant.compare - variant.price) * 100) / variant.compare) : 0;
        const savePill = sale && el.closest('.product__price') ? `<span class="price__save">${data.saveText.replace('__PERCENT__', percent)}</span>` : '';
        el.innerHTML = `<div class="price${sale ? ' price--sale' : ''}"><span class="price__current">${variant.priceHtml}</span>${sale ? `<s class="price__compare">${variant.compareHtml}</s>` : ''}${savePill}</div>`;
      });
      if (stockNote) {
        const low = variant.qty !== null && variant.qty > 0 && variant.qty <= data.lowStock;
        const textEl = $('[data-stock-text]', stockNote) || stockNote;
        textEl.textContent = low ? data.lowStockText.replace('__COUNT__', variant.qty) : '';
        stockNote.hidden = !low;
      }
      if (fromUser && section.hasAttribute('data-update-url')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
      if (fromUser && variant.mediaId) goToMedia(variant.mediaId);
    }

    picker && picker.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option-input]')) return;
      const group = e.target.closest('.variant-picker__group');
      if (data.sizeIndex > -1 && Number(group.dataset.optionIndex) === data.sizeIndex) {
        sizeChosen = true;
        if (expressGuard) expressGuard.hidden = true;
        picker.classList.remove('has-error');
        sizeError && (sizeError.hidden = true);
      }
      update(true);
    });

    function requireSize() {
      if (sizeChosen) return true;
      picker && picker.classList.add('has-error');
      if (sizeError) sizeError.hidden = false;
      const sizeGroup = picker && $(`.variant-picker__group[data-option-index="${data.sizeIndex}"]`, picker);
      sizeGroup && sizeGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    // Bundle offer (pack of 2): quantity + button label
    const bundle = $('[data-bundle]', section);
    const bundleQty = () => {
      const checked = bundle && $('[data-bundle-input]:checked', bundle);
      return checked ? Number(checked.value) : 1;
    };
    // Pack of 2: the 2nd item can be another variant / size
    const bundleCatalogEl = bundle && $('[data-bundle-catalog]', bundle);
    const bundleCatalog = bundleCatalogEl ? JSON.parse(bundleCatalogEl.textContent) : [];
    const bundleProduct = bundle && $('[data-bundle-product]', bundle);
    const bundleSize = bundle && $('[data-bundle-size]', bundle);
    const bundleImg = bundle && $('[data-bundle-pick-img]', bundle);
    bundleProduct && bundleProduct.addEventListener('change', () => {
      const p = bundleCatalog.find((x) => x.handle === bundleProduct.value);
      if (p && p.img && bundleImg) bundleImg.src = p.img;
    });
    function bundleItems() {
      const firstId = Number(idInput.value);
      if (bundleQty() < 2) return [{ id: firstId, quantity: 1 }];
      const first = data.variants.find((v) => v.id === firstId);
      const p = bundleProduct && bundleCatalog.find((x) => x.handle === bundleProduct.value);
      const size = (bundleSize && bundleSize.value) || (first && first.options[Math.max(0, data.sizeIndex)]);
      const second = p && p.variants.find((v) => v.size === size);
      if (!second) return [{ id: firstId, quantity: 2 }];
      if (!second.available) { toast(`Size ${size} is sold out — please pick another size.`); return null; }
      return second.id === firstId ? [{ id: firstId, quantity: 2 }] : [{ id: firstId, quantity: 1 }, { id: second.id, quantity: 1 }];
    }
    if (addBtn) addBtn.dataset.label = addBtn.textContent.trim();
    function syncBundleLabel() {
      if (!addBtn || addBtn.disabled) return;
      const q = bundleQty();
      addBtn.textContent = q > 1 ? `${addBtn.dataset.label} · ${q} items` : addBtn.dataset.label;
    }
    bundle && bundle.addEventListener('change', syncBundleLabel);
    picker && picker.addEventListener('change', () => setTimeout(syncBundleLabel, 0));
    setTimeout(syncBundleLabel, 0);

    form && form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!requireSize()) return;
      const items = bundleItems(); if (!items) return;
      addToCart(items, 1, addBtn);
    });
    buyNowBtn && buyNowBtn.addEventListener('click', async () => {
      if (!requireSize()) return;
      const buyItems = bundleItems(); if (!buyItems) return;
      buyNowBtn.classList.add('is-loading');
      try {
        const res = await fetch(`${theme.routes.cart_add}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: buyItems })
        });
        if (!res.ok) { const err = await res.json(); toast(err.description || err.message || 'Error'); return; }
        window.location.href = `${theme.routes.root}checkout`;
      } catch (e) {
        toast('Something went wrong. Please try again.');
      } finally {
        buyNowBtn.classList.remove('is-loading');
      }
    });
    expressGuard && expressGuard.addEventListener('click', (e) => { e.preventDefault(); requireSize(); });
    stickyBtn && stickyBtn.addEventListener('click', () => {
      if (!requireSize()) return;
      const items = bundleItems(); if (!items) return;
      addToCart(items, 1, stickyBtn);
    });

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.thumb)));
    prevBtn && prevBtn.addEventListener('click', () => showSlide(currentIndex() - 1));
    nextBtn && nextBtn.addEventListener('click', () => showSlide(currentIndex() + 1));
    if (track) {
      let raf;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(syncGallery); }, { passive: true });
      syncGallery();
    }

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(addBtn);
    }

    update(false);
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(async (el) => {
      if (el.children.length) return;
      try {
        const res = await fetch(el.dataset.url);
        const doc = parseHTML(await res.text());
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; syncWishlistButtons(el); }
      } catch (e) { /* recommendations are optional */ }
    });
  }

  /* ---------- Sale countdown (real end date from Theme settings) ---------- */
  function initCountdowns(ctx = document) {
    const timers = $$('[data-countdown]', ctx).filter((el) => !el.dataset.countdownReady);
    if (!timers.length) return;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const now = Date.now();
      timers.forEach((el) => {
        const end = Date.parse(el.dataset.countdown);
        const valueEl = $('[data-countdown-value]', el);
        if (Number.isNaN(end) || end - now <= 0) { el.hidden = true; return; }
        const diff = Math.floor((end - now) / 1000);
        const d = Math.floor(diff / 86400);
        const h = Math.floor((diff % 86400) / 3600);
        const m = Math.floor((diff % 3600) / 60);
        const sec = diff % 60;
        if (valueEl) valueEl.textContent = d > 0 ? `${d}d ${pad(h)}h ${pad(m)}m` : `${pad(h)}h ${pad(m)}m ${pad(sec)}s`;
        const set = (sel, v) => { const n = $(sel, el); if (n && n.textContent !== v) n.textContent = v; };
        set('[data-countdown-d]', String(d));
        set('[data-countdown-h]', pad(h));
        set('[data-countdown-m]', pad(m));
        set('[data-countdown-s]', pad(sec));
        el.hidden = false;
      });
    };
    timers.forEach((el) => { el.dataset.countdownReady = '1'; });
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Size chart in / cm switch ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-unit-btn]');
    if (!btn) return;
    const unit = btn.dataset.unitBtn;
    $$('.size-chart-table').forEach((table) => {
      table.dataset.unit = unit;
      $$('[data-unit-btn]', table).forEach((b) => b.classList.toggle('is-active', b.dataset.unitBtn === unit));
    });
    store.set('size-unit', unit);
  });
  function initSizeUnit() {
    const unit = store.get('size-unit', 'in');
    if (unit === 'in') return;
    $$('.size-chart-table').forEach((table) => {
      table.dataset.unit = unit;
      $$('[data-unit-btn]', table).forEach((b) => b.classList.toggle('is-active', b.dataset.unitBtn === unit));
    });
  }

  /* ---------- Accordions open by default on desktop only ---------- */
  function openDesktopAccordions(ctx = document) {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    $$('details[data-open-desktop]', ctx).forEach((d) => { d.open = true; });
  }

  /* ---------- Init ---------- */
  function init() {
    openDesktopAccordions();
    initCountdowns();
    initSizeUnit();
    initAnnouncement();
    initSearch();
    initSlideshows();
    $$('[data-product]').forEach(initProduct);
    initRecommendations();
    syncWishlistButtons();
    initWishlistPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', (e) => {
    openDesktopAccordions(e.target);
    initCountdowns(e.target);
    $$('[data-product]', e.target).forEach(initProduct);
    initSlideshows();
    initRecommendations();
    syncWishlistButtons(e.target);
  });
})();

document.addEventListener('change', (e) => {
  const sel = e.target.closest('[data-cart-nudge-select]');
  if (!sel) return;
  const img = document.querySelector('[data-cart-nudge-img]');
  const opt = sel.options[sel.selectedIndex];
  if (img && opt && opt.dataset.img) img.src = opt.dataset.img;
});
